import React from 'react';
import CheckboxInput from '../checkbox-input';

const GenderRow = ({filter, conditionsList, updateCondition, updateValue}) => {
  return (
    <span>
      <select value={filter.condition} onChange={e=> updateCondition(e.target.value)}>
        { conditionsList.map((o, i) => <option key={i} value={o}>{o}</option>) }
      </select>&nbsp;
      { 'is empty' != filter.condition &&
        <select value={filter.value} onChange={e=> updateValue(e.target.value)}>
          { ['male','female','Prefer not to say'].map((o, i) => <option key={i} value={o}>{o}</option>) }
        </select>
      }
    </span>
  )
}

export default GenderRow
